'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setBackTo = undefined;

var _superagent = require('superagent');

var _superagent2 = _interopRequireDefault(_superagent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Sets the back_to in the rails session
 * @param {Object} options
 * @param {String} options.url      URL the back to link should navigate to
 * @param {String} options.title    Title key for the back to link
 */
var setBackTo = exports.setBackTo = function setBackTo(_ref) {
  var url = _ref.url,
      title = _ref.title;

  _superagent2.default.get('/session/back_to').set('Content-Type', 'application/json').query({ url: url, title: title, redirect: true }).end();
};

exports.default = {
  setBackTo: setBackTo
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/utils-rails/lib/index.js
// module id = 1566
// module chunks = 1